import { render } from "./SmartdebitComponent.vue?vue&type=template&id=1e841f5e&scoped=true"
import script from "./SmartdebitComponent.vue?vue&type=script&lang=js"
export * from "./SmartdebitComponent.vue?vue&type=script&lang=js"

import "./SmartdebitComponent.vue?vue&type=style&index=0&id=1e841f5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e841f5e"]])

export default __exports__